import Status from "./Status";
import User from "./User";

export default class Workflow {
  constructor({
    id = Number.NaN,
    name = "",
    primaryStatus = Number.NaN,
    inactivityDaysLimit = null,
    campaign = {
      id: Number.NaN,
      name: "",
    },
    statuses = [],
    nexusFolderCreationEnabled = false,
    nexusFolderCreateButtonLabel = "",
    nexusFolderNameInputLabel = "",
    nexusFolderAssignedCollaborator = null,
    sendCollectionEmails = false,
    nexusFolderContactSelectionAllowed = false,
    nexusFolderContactCreationAllowed = false,
    deletionDelay = NaN,
    nexusFolderCreationRestrictedTo = [],
    nexusFolderFormTpl = null,
    state = "OPEN",
  } = {}) {
    this.id = Number.parseInt(id);
    this.name = name;
    this.inactivityDaysLimit = inactivityDaysLimit;
    this.primaryStatus = Number.parseInt(primaryStatus);
    this.campaign = campaign;
    this.statuses = statuses
      ? statuses.map((status) => new Status(status))
      : [];
    this.nexusFolderCreationEnabled = nexusFolderCreationEnabled;
    this.nexusFolderCreateButtonLabel = nexusFolderCreateButtonLabel;
    this.nexusFolderNameInputLabel = nexusFolderNameInputLabel;
    this.nexusFolderAssignedCollaborator = nexusFolderAssignedCollaborator;
    this.sendCollectionEmails = sendCollectionEmails;
    this.deletionDelay = deletionDelay;
    this.state = state;
    this.nexusFolderContactSelectionAllowed =
      nexusFolderContactSelectionAllowed;
    this.nexusFolderContactCreationAllowed = nexusFolderContactCreationAllowed;
    this.nexusFolderCreationRestrictedTo = nexusFolderCreationRestrictedTo.map(
      (user) => new User(user)
    );
    this.nexusFolderFormTpl = nexusFolderFormTpl;
  }
}
